import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import useMobileLayout from '@/hooks/use-mobile-layout';

// On mobile the sidebar overlays the document, so it starts closed there and closes again once the
// reader picks something from it.
const useInvestigationSidebar = () => {
  const $ = _c(9);
  const isMobile = useMobileLayout();
  const [userOpen, setUserOpen] = useState(null);
  const isOpen = userOpen ?? !isMobile;
  let t0;
  if ($[0] !== isOpen) {
    t0 = () => setUserOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setUserOpen(false);
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isMobile) {
    t2 = () => {
      if (isMobile) {
        setUserOpen(false);
      }
    };
    $[3] = isMobile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isOpen || $[6] !== t0 || $[7] !== t2) {
    t3 = {
      isOpen,
      toggle: t0,
      close: t1,
      closeOnMobile: t2
    };
    $[5] = isOpen;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default useInvestigationSidebar;